import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useComingSoon } from '../context/ComingSoonContext';
import ComingSoon from '../pages/ComingSoon';

// Routes accessibles meme quand le gate est actif et que le visiteur n'est ni
// dans METERIS_DEV_IPS ni authentifie : login admin, login/signup clients,
// pages legales (obligation legale RGPD + mentions).
const PUBLIC_WHITELIST_PREFIXES = [
  '/my',
  '/admin',
  '/compte/connexion',
  '/compte/inscription',
  '/mentions-legales',
  '/confidentialite',
];

function isWhitelisted(pathname) {
  return PUBLIC_WHITELIST_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto border-2 border-[#272a30] border-t-[#F59E0B] rounded-full animate-spin" />
        <p className="mt-4 text-sm text-[#9CA3AF]" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Chargement…
        </p>
      </div>
    </div>
  );
}

export default function ComingSoonGate({ children }) {
  const location = useLocation();
  const { enabled, isDev, loading: csLoading } = useComingSoon();
  const { isAuthenticated, loading: authLoading } = useAuth();

  if (csLoading || authLoading) return <Splash />;

  if (!enabled) return children;
  if (isDev) return children;
  if (isAuthenticated) return children;
  if (isWhitelisted(location.pathname)) return children;

  return <ComingSoon />;
}
